import React from 'react'
import * as h from '../../helpers/helpers';
import { H1, H2, TX_B, TXC, TXC_B, TXR_B, TXR_I, TXR_II } from "../../styles/urar-styles";

export function OVERALL_LIST({value}) {
	// v[ 0[ "et","ev"], 0[ 1["it","iv"], 1["it","iv"] ] ]

	return (
		<>
		{
			value.map((r0, ei) => {
				var ql = r0[0];
				var il = r0[1];

				var qt = ql[0];
				var qv = ql[1];

				var space = (ei > 0);
				return (
					<React.Fragment key={ei}>
						<TXR_I title={qt} value={qv} space={space} />
						{
							il.map((r2, ii) => {
								var it = r2[0];
								var iv = r2[1];
								return(
									<TXR_I key={ii} title={it} value={iv} />
								)
							})
						}
					</React.Fragment>
				)
			})
		}
		</>		
	)
}